import { marker } from "@jsverse/transloco-keys-manager/marker";
import { NavigationBarItem } from "src/app/modules/bootstrap/bootstrap-components/navigation-bar/navigation-bar-item";
import { routes_platform } from "src/app/routing/routes";
import { COLORS_FOR_MODULES } from "src/app/support/colors";
import { sntTranslate } from "src/app/support/translate";

export async function getPlatoformNavigationBarMenu(providers: {}): Promise<
  NavigationBarItem[]
> {
  return [
    {
      icon: "fa-inbox-in",
      title: sntTranslate(marker("Inbox")),
      url: routes_platform.inbox.master(),
      disabled: false,
      color: COLORS_FOR_MODULES.PLATFORM_INBOX
    },
    {
      icon: "fa-suitcase-medical",
      title: sntTranslate(marker("Catalogo")),
      url: routes_platform.catalog.master(),
      disabled: false,
      color: COLORS_FOR_MODULES.PLATFORM_CATALOG
    },
    {
      icon: "fa-box",
      title: sntTranslate(marker("Ordini")),
      url: routes_platform.orders.master(),
      disabled: false,
      color: COLORS_FOR_MODULES.PLATFORM_ORDERS
    },
    {
      icon: "fa-users",
      title: sntTranslate(marker("Utenti")),
      url: routes_platform.members.master(),
      disabled: false,
      color: COLORS_FOR_MODULES.PLATFORM_MANAGER_USERS
    }
  ];
}
